
import { PlatformStatisticsService } from "./platformStatistics";
import { CategoryService } from "./categoryStatistics";
import { AgentDiscoveryService } from "./agentDiscovery";

// Aggregated service for all statistics
export const StatisticsService = {
  platform: PlatformStatisticsService,
  categories: CategoryService,
  discovery: AgentDiscoveryService
};
